/**
 * Portal Manta · agAluciGuardABNT
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { aluciAuditarTexto } from './aluciAuditarTexto.jsx';

function agAluciGuardABNT(ctx, prev){
  if (!ctx || !ctx.texto) return {status:'sem-texto', msg:'aguardando texto para auditar'};
  const env = aluciAuditarTexto(ctx.texto, ctx.opcoes);
  const achados = env.achados.filter(a => a.tipo === 'AL-01_abnt' || a.tipo === 'AL-01_lei');
  return {sub:'Auditor ABNT/Lei', status:achados.length===0?'ok':'atencao', msg:achados.length+' aluci AL-01 (norma/lei)', achados};
}

export { agAluciGuardABNT };
export default agAluciGuardABNT;
